import * as React from 'react';
import { Close } from '@liveauctioneers/hammer-ui-core/icons';
import { H2, H6 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import styled from 'styled-components';

type Props = {
    readonly currentImageIndex: number;
    readonly galleryLength: number;
    readonly galleryTitle: React.ReactNode;
    readonly onClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const Header = ({ currentImageIndex, galleryLength, galleryTitle, onClose }: Props) => (
    <HeaderContainer>
        {/* Header content */}
        <ContentContainer>
            <H2>{galleryTitle}</H2>
            <IconButton
                icon={Close}
                onClick={onClose}
            />
        </ContentContainer>

        {/* Stuff that hangs on top of image */}
        <OverlayContainer>
            <ImageIndexCounter>
                <H6 $white>
                    {currentImageIndex + 1} of {galleryLength}
                </H6>
            </ImageIndexCounter>
        </OverlayContainer>
    </HeaderContainer>
);

export default Header;

const HeaderContainer = styled.header`
    position: relative;
    background-color: ${({ theme }) => theme.colors.grey500};
    padding: 10px 20px;
    z-index: 10;
    user-select: none;
`;

const ContentContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const ImageIndexCounter = styled.div`
    padding: 3px 12px;
    opacity: 0.85;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.grey100};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const OverlayContainer = styled.div`
    position: absolute;
    top: 95px;
    right: 0;
    left: 0;
    height: 0;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobileWidth}) {
        top: 75px;
    }
`;
